import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const CustomLinearProgress = styled(LinearProgress)(({ thickness }) => ({
  height: thickness || 4,
  borderRadius: 100,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#E0E2E8',
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: '#2F9D6D',
  },
}));

export default function Progress({ value, total, label, options }) {
  const { determinate, thickness, loading, showPercentage } = options || {};
  const percentageValue =
    typeof value === 'number' && typeof total === 'number' && Math.round((value / total) * 100);

  if (!loading) {
    return (
      <Box className="w-full">
        {label && (
          <Typography className="font-600 text-12 text-typography-secondary">{label}</Typography>
        )}
        <Box>
          <CustomLinearProgress
            thickness={thickness}
            variant="determinate"
            value={percentageValue || 0}
          />
        </Box>
      </Box>
    );
  }

  if (!determinate) {
    return (
      <Box className="w-full">
        {label && (
          <Typography className="font-600 text-12 text-typography-secondary">{label}</Typography>
        )}
        <Box>
          <CustomLinearProgress thickness={thickness} />
        </Box>
      </Box>
    );
  }

  return (
    <Box className="w-full">
      {label && (
        <Typography className="font-600 text-12 text-typography-secondary">{label}</Typography>
      )}
      <Box className="flex items-center gap-4">
        <CustomLinearProgress
          variant="determinate"
          thickness={thickness}
          value={percentageValue}
          className="w-full"
        />
        {showPercentage && (
          <Typography className="font-500 text-12 text-typography-secondary w-[34px] text-right">
            {percentageValue}%
          </Typography>
        )}
      </Box>
    </Box>
  );
}
